import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';
import alasql from 'alasql';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import theme from '../../../../../../assets/styles/theme/theme';
import { IInvoiceData } from '../../../../../../store/ducks/invoices/types';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { ITaggingParams } from '../../../../../../store/ducks/tagging/types';
import { formatCurrency } from '../../../../../../utils/formatNumbers';

interface IExportNFProps {
  invoices: IInvoiceData[];
}

export interface INFExcelColumns {
  ['Empresa']: string;
  ['Nº da NF']: string;
  ['Nº do pedido']: string;
  ['Ordem de venda']: string;
  ['Tipo']: string;
  ['Chave de acesso NF']: string;
  ['Data de faturamento']: string;
  ['Data de vencimento']: string;
  ['Status']: string;
  ['Valor total']: string;
}

const ExportData: React.FC<IExportNFProps> = ({ invoices }) => {
  const dispatch = useDispatch();
  const exportExcel = () => {
    const taggingParams: ITaggingParams = {
      screenName: 'LG:Financas:MinhasFinancas:Duplicatas',
      event: 'click',
      itemName: 'button:exportar_dados',
      itemDescription: 'financas_minhas_financas_duplicatas_exportarDados'
    };
    dispatch(sendTagging(taggingParams));
    const fileName = `Duplicatas ${moment().format('DD_MM_YYYY')}`;
    generateInvoicesExcel(invoices, fileName);
  };

  const generateInvoicesExcel = (
    invoices: IInvoiceData[],
    fileName: string
  ) => {
    const data: INFExcelColumns[] = [];

    invoices.forEach((invoice) => {
      const row: INFExcelColumns = {
        Empresa: invoice.companyCode || ' - ',
        'Nº da NF': invoice.invoiceNumber,
        'Nº do pedido': invoice.purchaseOrder,
        'Ordem de venda': invoice.salesOrders ? invoice.salesOrders : ' - ',
        Tipo: invoice.documentType,
        'Chave de acesso NF': invoice.nfeAccessKey,
        'Data de faturamento': moment(invoice.invoiceDate, 'YYYY-MM-DD').format(
          'DD/MM/YYYY'
        ),
        'Data de vencimento': invoice.dueDate
          ? moment(invoice.dueDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : ' - ',
        Status: invoice.status,
        'Valor total':
          invoice.openInvoiceAmount === 'Indisponível'
            ? invoice.openInvoiceAmount
            : `R$ ${formatCurrency(invoice.openInvoiceAmount)}`
      };

      data.push(row);
    });

    const opts = {
      headers: true,
      column: {
        style: {
          width: 200,
          Font: { Bold: '1' },
          Interior: { Color: theme.colors.waterBlue, Pattern: 'Solid' },
          Alignment: { Horizontal: 'Left' }
        }
      },
      row: {
        style: {
          Font: { Color: theme.colors.black },
          Alignment: { Horizontal: 'Left' }
        }
      },
      columns: [
        { width: 100, height: 100, columnid: 'Empresa' },
        { width: 100, height: 100, columnid: 'Nº da NF' },
        { width: 100, height: 100, columnid: 'Nº do pedido' },
        { width: 100, height: 100, columnid: 'Ordem de venda' },
        { width: 100, height: 100, columnid: 'Tipo' },
        { width: 350, height: 100, columnid: 'Chave de acesso NF' },
        { width: 100, height: 100, columnid: 'Data de faturamento' },
        { width: 100, height: 100, columnid: 'Data de vencimento' },
        { width: 100, height: 100, columnid: 'Status' },
        { width: 100, height: 100, columnid: 'Valor total' }
      ]
    };

    alasql('SELECT * INTO XLSXML("' + fileName + '.xls",?) FROM ?', [
      opts,
      data
    ]);
  };

  return (
    <Button
      name="exportDuplicate"
      onClick={exportExcel}
      icon={<Icon option="Download" />}
      iconPosition="left"
      variant="secondary"
    >
      Exportar dados
    </Button>
  );
};

export default ExportData;
